module.exports = __webpack_public_path__ + "static/vid-leds-62decec9ab6450314cab413b8ffb86ef.mp4";